<template>
  <div id="app">
    <!-- 顶部导航栏 -->
    <nav class="navbar" :class="{ 'navbar-fixed': isNavbarFixed }">
      <div class="nav-container">
        <div class="nav-logo">
          <img src="../src/assets/FpeNYGjFp1F8tkES0uF2rgS0Z_ue.png" :alt="$t('hero.title')" />
          <span>{{ $t('hero.title').split('，')[0] }}</span>
        </div>
        <ul class="nav-menu" :class="{ 'nav-menu-active': isMobileMenuActive }">
          <li><router-link to="/" @click.native="closeMobileMenu">{{ $t('nav.home') }}</router-link></li>
          <li><router-link to="/#store" @click.native="scrollToStore">{{ $t('nav.store') }}</router-link></li>
          <li><router-link to="/#about" @click.native="scrollToAbout">{{ $t('nav.about') }}</router-link></li>
          <li><router-link to="/#news" @click.native="scrollToNews">{{ $t('nav.news') }}</router-link></li>
          <li><router-link to="/#applications" @click.native="scrollToApplications">{{ $t('nav.applications') }}</router-link></li>
          <li><router-link to="/#contact" @click.native="scrollToContact">{{ $t('nav.contact') }}</router-link></li>
          <li class="nav-actions">
            <!-- <button class="btn btn-primary nav-store-btn" @click="scrollToStore">{{ $t('footer.viewIntroduction') }}</button> -->
          </li>
        </ul>
        <div class="nav-toggle" @click="toggleMobileMenu">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>

    <!-- 主要内容区域 -->
    <main class="main-content">
      <router-view :key="$route.fullPath"></router-view>
    </main>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-left">
            <div class="footer-logo">
              <img src="../src/assets/FpeNYGjFp1F8tkES0uF2rgS0Z_ue.png" :alt="$t('hero.title')" />
              <span>{{ $t('hero.title').split('，')[0] }}</span>
            </div>
            <p class="footer-company">{{ $t('footer.company') }}</p>
          </div>
          <div class="footer-center">
            <div class="footer-section">
              <h4>{{ $t('footer.aboutUs') }}</h4>
              <ul>
                <li>{{ $t('footer.ourConcept') }}</li>
                <li>{{ $t('footer.ourHistory') }}</li>
              </ul>
            </div>
          </div>
          <div class="footer-right">
            <div class="footer-section">
              <h4>{{ $t('footer.contactUs') }}</h4>
              <ul>
                <li>{{ $t('footer.phone') }}</li>
                <li>{{ $t('footer.email') }}</li>
              </ul>
            </div>
            <div class="footer-social">
              <div class="social-icon" @click="showDouyinModal">
                <img src="../src/assets/icon/douyin.png" alt="抖音" />
              </div>
              <div class="social-icon">
               <a href="https://space.bilibili.com/3537116501904153" target="_blank" style="display: flex; align-items: center; justify-content: center;">
                <img src="../src/assets/icon/bili.png" alt="哔哩哔哩" />  
              </a>
              </div>
              <div class="social-icon" @click="showWechatModal">
                <img src="../src/assets/icon/wechat.png" alt="微信二维码" width="35px" height="35px" style="border-color: white;" /> 
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>

    <!-- 抖音二维码弹窗 -->
    <div v-if="isDouyinModalVisible" class="modal-overlay" @click="hideDouyinModal">
      <div class="douyin-modal" @click.stop>
        <div class="modal-header">
          <div class="modal-title">
            <img src="../src/assets/icon/douyin.png" alt="抖音" class="modal-douyin-icon" />
            <span>抖音</span>
          </div>
          <button class="modal-close" @click="hideDouyinModal">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
        <div class="modal-content">
          <div class="qr-code-container">
             <div class="qr-code-placeholder">
                <img src="../src/assets/douyin_backed.png" alt="抖音二维码" class="qr-code-image" />
             </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 微信二维码弹窗 -->
    <div v-if="isWechatModalVisible" class="modal-overlay" @click="hideWechatModal">
      <div class="wechat-modal" @click.stop>
        <div class="modal-header">
          <div class="modal-title">
            <!-- <img src="../src/assets/icon/ercode.png" alt="微信" class="modal-wechat-icon" width="32px" height="32px" /> -->
            <span>微信</span>
          </div>
          <button class="modal-close" @click="hideWechatModal">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
        <div class="modal-content">
          <div class="qr-code-container">
             <div class="qr-code-placeholder">
                <img src="../src/assets/icon/ercode.png" alt="微信二维码" class="qr-code-image" width="200px" height="200px" />
              </div>
              </div>
              </div>
</div>
              </div>


  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isNavbarFixed: false,
      isMobileMenuActive: false,
      cartCount: 0,
      isDouyinModalVisible: false,
      isWechatModalVisible: false,
    }
  },
  mounted() {
    this.initScrollHandler();
  },
  methods: {
    // 初始化滚动监听
    initScrollHandler() {
      window.addEventListener('scroll', this.handleScroll);
    },
    // 处理滚动事件
    handleScroll() {
      this.isNavbarFixed = window.scrollY > 100;
    },
    // 切换移动端菜单
    toggleMobileMenu() {
      this.isMobileMenuActive = !this.isMobileMenuActive;
    },
    // 关闭移动端菜单
    closeMobileMenu() {
      this.isMobileMenuActive = false;
    },
    // 滚动到商店区域
    scrollToStore() {
      this.navigateAndScroll('store');
      this.closeMobileMenu();
    },
    // 滚动到关于我们区域
    scrollToAbout() {
      this.navigateAndScroll('about');
      this.closeMobileMenu();
    },
    // 滚动到产品特点区域
    scrollToFeatures() {
      this.navigateAndScroll('features');
      this.closeMobileMenu();
    },
    // 滚动到新闻区域
    scrollToNews() {
      this.navigateAndScroll('news');
      this.closeMobileMenu();
    },
    // 滚动到应用场景区域
    scrollToApplications() {
      this.navigateAndScroll('applications');
      this.closeMobileMenu();
    },
    // 滚动到联系我们区域
    scrollToContact() {
      this.navigateAndScroll('contact');
      this.closeMobileMenu();
    },
    // 导航到首页并滚动到指定区域
    navigateAndScroll(sectionId) {
      // 如果当前已经在首页，直接滚动
      if (this.$route.path === '/') {
        this.$nextTick(() => {
          this.scrollToSection(sectionId);
        });
      } else {
        // 如果不在首页，先导航到首页再滚动
        this.$router.push('/').then(() => {
          this.$nextTick(() => {
            this.scrollToSection(sectionId);
          });
        }).catch(err => {
          // 捕获导航重复错误，直接滚动
          if (err.name === 'NavigationDuplicated') {
            this.$nextTick(() => {
              this.scrollToSection(sectionId);
            });
          }
        });
      }
    },
    // 滚动到指定区域
    scrollToSection(sectionId) {
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const navHeight = 80; // 导航栏高度
          const elementPosition = element.offsetTop - navHeight;
          
          window.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    },
    // 显示抖音弹窗
    showDouyinModal() {
      this.isDouyinModalVisible = true;
      // 防止背景滚动
      document.body.style.overflow = 'hidden';
    },
    // 隐藏抖音弹窗
    hideDouyinModal() {
      this.isDouyinModalVisible = false;
      // 恢复背景滚动
      document.body.style.overflow = 'auto';
    },
    // 显示微信弹窗
    showWechatModal() {
      this.isWechatModalVisible = true;
      // 防止背景滚动
      document.body.style.overflow = 'hidden';
    },
    // 隐藏微信弹窗
    hideWechatModal() {
      this.isWechatModalVisible = false;
      // 恢复背景滚动
      document.body.style.overflow = 'hidden';
    },
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<style scoped>
/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  line-height: 1.6;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 按钮样式 */
.btn {
  display: inline-block;
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
}

.btn-primary {
  background: linear-gradient(135deg, #4CAF50, #2E7D32);
  color: white;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #45a049, #1B5E20);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
}

.btn-secondary {
  background: white;
  color: #4CAF50;
  border: 2px solid #4CAF50;
}

.btn-secondary:hover {
  background: #4CAF50;
  color: white;
}

.btn-outline {
  background: transparent;
  color: white;
  border: 2px solid white;
}

.btn-outline:hover {
  background: white;
  color: #4CAF50;
}

.btn-full {
  width: 100%;
}

/* 顶部导航栏 */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  padding: 0;
}

.navbar-fixed {
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
}

.nav-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 24px;
  font-weight: 700;
  color: #2E7D32;
}

.nav-logo img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 24px; /* 减少间距从40px到24px */
  margin: 0;
  align-items: center;
  flex: 1;
  justify-content: center; /* 居中导航项 */
  max-width: calc(100% - 400px); /* 为logo和操作区域预留空间 */
}

.nav-menu li a {
  text-decoration: none;
  color: #333;
  font-weight: 500;
  font-size: 15px; /* 稍微减小字体 */
  padding: 8px 4px; /* 调整内边距 */
  position: relative;
  transition: color 0.3s ease;
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px; /* 限制最大宽度 */
}

.nav-menu li a:hover,
.nav-menu li a.router-link-active {
  color: #4CAF50;
}

.nav-menu li a::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 0;
  height: 2px;
  background: #4CAF50;
  transition: width 0.3s ease;
}

.nav-menu li a:hover::after,
.nav-menu li a.router-link-active::after {
  width: 100%;
}

/* 导航栏操作区域 */
.nav-actions {
  display: flex;
  align-items: center;
  gap: 12px; /* 减少间距 */
  flex-shrink: 0; /* 防止收缩 */
  min-width: 200px; /* 确保最小宽度 */
}

.language-switcher {
  position: relative;
  flex-shrink: 0;
}

.language-select {
  background: transparent;
  border: 1px solid #E5E5E5;
  border-radius: 4px;
  padding: 4px 6px; /* 减少内边距 */
  color: #333;
  font-size: 13px; /* 减小字体 */
  cursor: pointer;
  transition: border-color 0.3s ease;
  min-width: 70px;
}

.language-select:hover {
  border-color: #4CAF50;
}

.language-select:focus {
  outline: none;
  border-color: #4CAF50;
}

.nav-store-btn {
  padding: 6px 16px; /* 减小按钮 */
  font-size: 13px;
  border-radius: 20px;
  white-space: nowrap;
  flex-shrink: 0;
}

.cart-icon {
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}

.cart-symbol {
  font-size: 20px;
}

.cart-count {
  position: absolute;
  top: -5px;
  right: -5px;
  background: #FF5722;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
}

.nav-toggle {
  display: none;
  flex-direction: column;
  cursor: pointer;
  gap: 4px;
}

.nav-toggle span {
  width: 25px;
  height: 3px;
  background: #333;
  transition: all 0.3s ease;
}

/* 中等屏幕适配 (768px - 1024px) */
@media (max-width: 1024px) {
  .nav-menu {
    gap: 16px;
    max-width: calc(100% - 350px);
  }
  
  .nav-menu li a {
    font-size: 14px;
    max-width: 100px;
  }
  
  .nav-actions {
    gap: 10px;
    min-width: 180px;
  }
  
  .nav-store-btn {
    padding: 5px 12px;
    font-size: 12px;
  }
}

/* 超长文本处理 */
@media (max-width: 1200px) and (min-width: 769px) {
  .nav-menu li a {
    position: relative;
  }
  
  .nav-menu li a[data-full-text]:hover::before {
    content: attr(data-full-text);
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 1001;
    margin-top: 5px;
  }
}

/* 小屏幕优化 (480px - 768px) */
@media (max-width: 480px) {
  .nav-container {
    padding: 0 15px;
  }
  
  .nav-logo {
    font-size: 20px;
  }
  
  .nav-logo img {
    width: 35px;
    height: 35px;
  }
  
  .nav-actions {
    gap: 8px;
    min-width: 150px;
  }
  
  .language-select {
    font-size: 12px;
    padding: 3px 5px;
    min-width: 60px;
  }
  
  .nav-store-btn {
    padding: 4px 10px;
    font-size: 11px;
  }
  
  .cart-icon {
    width: 35px;
    height: 35px;
  }
  
  .cart-symbol {
    font-size: 18px;
  }
}

/* 移动端导航 */
@media (max-width: 768px) {
  .nav-toggle {
    display: flex;
  }
  
  .nav-menu {
    position: fixed;
    top: 80px;
    left: 0;
    right: 0;
    background: white;
    flex-direction: column;
    padding: 20px;
    transform: translateY(-100%);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    gap: 20px;
    max-width: 100%;
  }
  
  .nav-menu li a {
    font-size: 16px;
    max-width: none;
    text-align: center;
  }
  
  .nav-menu-active {
    transform: translateY(0);
    opacity: 1;
    visibility: visible;
  }
}

/* 主要内容区域 */
.main-content {
  margin-top: 80px;
}

/* 页脚 */
.footer {
  background: #2E7D32;
  color: white;
  padding: 60px 0 30px;
}

.footer-content {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 60px;
}

.footer-left {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 24px;
  font-weight: 700;
}

.footer-logo img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.footer-company {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
}

.footer-section h4 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  color: white;
}

.footer-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-section li {
  margin-bottom: 12px;
}

.footer-section a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-section a:hover {
  color: #4CAF50;
}

.footer-social {
  display: flex;
  gap: 15px;
  align-items: center;
  justify-content: start;
}

.social-icon {
  width: 25px;
  height: 25px;
  /* background: #E8F5E8; */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4CAF50;
  cursor: pointer;
  transition: all 0.3s ease;
}

/* .social-icon:hover {
  background: #4CAF50;
  color: white;
  transform: translateY(-2px);
} */

/* 移动端适配 */
@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: 40px;
    text-align: center;
  }
  
  .footer-left,
  .footer-center,
  .footer-right {
    align-items: center;
  }
  
  .footer-social {
    justify-content: center;
  }
}

/* 抖音弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.douyin-modal {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 400px;
  width: 90%;
  max-height: 90vh;
  overflow: hidden;
  animation: slideUp 0.3s ease;
  position: relative;
}

.wechat-modal {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 400px;
  width: 90%;
  max-height: 90vh;
  overflow: hidden;
  animation: slideUp 0.3s ease;
  position: relative;
}

@keyframes slideUp {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 16px;
  border-bottom: 1px solid #f0f0f0;
}

.modal-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.modal-douyin-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.modal-close {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  color: #666;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-close:hover {
  background: #f5f5f5;
  color: #333;
}

.modal-content {
  padding: 24px;
}

.qr-code-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.qr-code-placeholder {
  width: 325px;
  height: 300px;
  margin-bottom: 20px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-code-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}

.qr-description {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.qr-subtitle {
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
}

.qr-actions {
  display: flex;
  gap: 20px;
  justify-content: center;
}

.qr-action-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 12px;
  border-radius: 12px;
  transition: all 0.2s ease;
  min-width: 80px;
}

.qr-action-item:hover {
  background: #f8f8f8;
}

.action-icon {
  width: 40px;
  height: 40px;
  background: #f0f0f0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  transition: all 0.2s ease;
}

.qr-action-item:hover .action-icon {
  background: #e0e0e0;
  color: #333;
}

.qr-action-item span {
  font-size: 12px;
  color: #666;
  font-weight: 500;
}

/* 移动端弹窗适配 */
@media (max-width: 480px) {
  .douyin-modal {
    width: 95%;
    max-width: none;
    margin: 20px;
  }
  
  .modal-header {
    padding: 16px 20px 12px;
  }
  
  .modal-title {
    font-size: 16px;
  }
  
  .modal-content {
    padding: 20px;
  }
  
  .qr-description {
    font-size: 18px;
  }
  
  .qr-actions {
    gap: 16px;
  }
  
  .qr-action-item {
    min-width: 70px;
    padding: 10px;
  }
  
  .action-icon {
    width: 36px;
    height: 36px;
  }
}
</style>